const $addToCart = $('.js-add-to-cart');
const $win = $(window);

$addToCart.on('click', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');

  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: $form.serialize()
  })
    .done(function() {
      $.ajax({
        url: '/cart',
        success: function(response) {
          const counterAddedProducts = $(response).find('.cart .cart__link span').text();

          $('.cart .cart__link span').text(counterAddedProducts);
        }
      });
    })
    .fail(function(error) {
      alert(error.responseJSON.description);
    });
});

// Scroll spy

function active_state() {
  $('.section--spy').each(function() {
    var sectOffset = $(this).offset().top;
    if (sectOffset <= $win.scrollTop() + 100) {
      var id = $(this).attr('id');

      $('#nav-product-links li').removeClass('current');
      $('#nav-product-links').find('a[href="#' + id + '"]').closest('li').addClass('current');
    }
  });
}

$win.on('scroll load', function() {
  active_state();
});



// WEBPACK FOOTER //
// ./../src/assets/js/product.js